import { Link } from "react-router-dom";
import CompanyName from "../../common/CompanyName";
import Counter from "../../common/Counter";
import ArrowIcon from "../../common/svg/ArrowIcon";
import {
  POTENTIAL_DATA,
  POTENTIAL_HEADING,
} from "../../constants/PotentialConstant";

const Potential = () => {
  return (
    <div className="home6-choose-section">
      <div className="container">
        <div className="row">
          {/* Top Section */}
          <div className="choose-top">
            <div className="row">
              <div className="col-lg-6">
                <div className="choose-title">
                  <span>Why Choose Us</span>
                  <h2>Unlock the potential of your business.</h2>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="choose-right-img magnetic-item">
                  <img
                    className="img-fluid"
                    src={POTENTIAL_HEADING.image}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="choose-btm">
            <div className="row g-lg-4 gy-5">
              {/* Left Content */}
              <div className="col-lg-7">
                <div className="choose-left-content">
                  <div className="vectors">
                    <img
                      className="choose-vec-top-r"
                      src={POTENTIAL_HEADING.topRight}
                      alt=""
                    />
                    <img
                      className="choose-vec-btm-l"
                      src={POTENTIAL_HEADING.bottomLeft}
                      alt=""
                    />
                  </div>

                  <div className="icon">
                    <Link to="/">
                      <img
                        alt="image"
                        className="img-fluid"
                        width={50}
                        height={50}
                        src="https://appthing-website.s3.ap-south-1.amazonaws.com/Logo.png"
                      />
                    </Link>
                    <CompanyName />
                  </div>

                  <h4>
                    {POTENTIAL_HEADING.companyTitle} <br />
                    <span> {POTENTIAL_HEADING.companySince} </span>
                  </h4>
                  <p> {POTENTIAL_HEADING.description} </p>

                  <div className="sl">
                    <h2>#1</h2>
                  </div>

                  <div className="about-btn">
                    <Link to="/">
                      <ArrowIcon width={7} height={7} />
                      About More
                    </Link>
                  </div>
                </div>
              </div>

              {/* Right Content */}
              <div className="col-lg-5">
                <div className="choose-feature">
                  <ul>
                    {POTENTIAL_DATA.map(
                      ({ id, value, suffix, title, description }) => (
                        <li key={id}>
                          <div className="single-feature">
                            <div className="progress">
                              <h3>
                                <Counter end={value} suffix={suffix} />
                              </h3>
                            </div>
                            <div className="content">
                              <h4> {title} </h4>
                              <p> {description} </p>
                            </div>
                          </div>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </div>
              {/* End Right Content */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Potential;
